import {http} from '../../plugins/http';
import {getData} from "../../utils/get";

export default {

    store(settings) {
        const data = new FormData();

        Object.keys(settings).forEach((field) => {
            data.append(field, settings[field] || '');
        });

        return http.post(`/api/v1/admin/system-settings`, data);
    },

    storeMaintenance(params) {
        return http.post(`/api/v1/admin/maintenance-settings`, params);
    },

    getSettings() {
        return http.get(`/api/v1/admin/system-settings`);
    },

    getMaintenanceSettings() {
        return http.get(`/api/v1/admin/maintenance-settings`);
    },

    sidebarLogoUrl() {
        return http.get(`/api/v1/admin/sidebar-logo-url`).then(getData);
    },

    systemCompany() {
        return http.get(`/api/v1/admin/system-company`).then(getData);
    },

    getConfigurationSettings() {
        return http.get(`/api/v1/admin/system-settings/configuration`).then(getData);
    },

    hasCommonLinkOnlyFeaturesInTenant(tenantId) {
        return http.get(`/api/v1/admin/system-settings/has-cl-only-features-in-tenant/${tenantId}`).then(getData);
    },

    isSlaPossible(projectKey, taskTypeKey) {
        return http.get(`/api/v1/admin/system-settings/is-sla-possible/${projectKey}/${taskTypeKey}`);
    },

    getPasswordResetSetting() {
        return http.get('/api/v1/admin/password-reset-setting');
    }

};



// WEBPACK FOOTER //
// ./src/services/Admin/SystemSettingsController.js